import { Popup } from 'mapbox-gl';
import trackEvent from '@Core/tracking';

export default class InfoWindow {
  #infoWindow = {}

  constructor(locData, map, e) {
    this.createMapboxInfoWindow(locData, map, e);
    addTrackEventListeners(map);
  }

  getDOMElement() {
    return this.#infoWindow.getContent();
  }

  open(map) {
    this.#infoWindow.addTo(map.get());
  }

  close() {
    this.#infoWindow.remove();
  }

  attachDOMEvents(fn) {
    this.addListener(() => {
      fn(document.getElementById(this.$id));
    });
  }

  addListener(fn) {
    this.#infoWindow.on('open', () => {
      fn();
    });
  }

  createMapboxInfoWindow(locData, map, e) {
    this.#infoWindow = new Popup()
      .setLngLat([locData.longitude, locData.latitude])
      .setHTML(getTemplateString(locData))
      .addTo(map.get());
    e.stopPropagation();
  }
}

function getTemplateString(locData) {
  return `<div class="location-info location-info-window" data-location-info-window>
            <h3 class="text-2xl normal-case mb-1">Boyer ${locData.title}</h3>
            <div class="mt-1">${locData.address}</div>
            <div class="mt-0.5">${locData.city}, ${locData.state} ${locData.zip}</div>
            <div class="mt-4 flex">
                <div>
                    <div class="location-info__label">Phone number</div>
                    <a
                        href="tel:+${locData.mainNumber}"
                        class="location-info__value"
                        data-comp-track-click-event
                        data-event-category="Location Search"
                        data-event-action="Phone - Location"
                        data-event-label="${locData.title} - Phone Number ${locData.mainNumber}"
                    >
                          ${locData.mainNumber}
                    </a>
                </div>
                ${locData.faxNumber ? `
                  <div class="pl-6">
                      <div class="location-info__label">Fax number</div>
                      <a
                          href="tel:+${locData.faxNumber}"
                          class="location-info__value"
                          data-comp-track-click-event
                          data-event-category="Location Search"
                          data-event-action="Phone - Location"
                          data-event-label="${locData.title} - Fax Number ${locData.faxNumber}"
                      >
                            ${locData.faxNumber}
                      </a>
                  </div>
                ` : ''}
            </div>
            <a href="${locData.url}" class="block mt-3 font-semibold">Location Details</a>
          </div>`;
}

function addTrackEventListeners(map) {
  const locationInfoWindow = map.$container.querySelector('[data-location-info-window]');
  const trackClickEventElements = locationInfoWindow.querySelectorAll('[data-comp-track-click-event]');
  trackClickEventElements.forEach(trackClickEventElement => {
    const {
      eventCategory,
      eventAction,
      eventLabel,
    } = trackClickEventElement.dataset;
    trackClickEventElement.addEventListener('click', () => {
      trackEvent(eventCategory, eventAction, eventLabel);
    });
  });
}
